export var MAX_IMAGE_SIZE = 1024 * 1024 * 5; // 5MB
export var STORAGE_KEYS = {
    OAUTH_CODE_VERIFIER: "oauth/code_verifier",
    AUTH_ACCESS_TOKEN: "auth/access_token",
};
